<template>
  <el-table-column
    prop="address.city"
    label="Város"
    show-overflow-tooltip
    min-width="150"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.address && scope.row.address.city }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'address.city',
  };
</script>
